import { Button } from "@progress/kendo-react-buttons";

export default function SettingsToolbar({ draft, onSave, t = {} }) {
  return (
    <section className="toolbar-panel">
      <div>
        <p className="eyebrow">{t.settings || "Settings"}</p>
        <h2>{t.workspaceControls || "Workspace controls"}</h2>
      </div>
      <Button themeColor="primary" icon="save" onClick={() => onSave(draft)}>
        {t.saveSettings || "Save settings"}
      </Button>
    </section>
  );
}
